import { ReactElement } from 'react';

import {
  Progress,
  Typography,
} from '@beeline/design-system-react/extracted-styles';

import styles from './styles.module.scss';

interface Props {
  text: string;
}

export function Preloader({ text }: Props): ReactElement {
  return (
    <div className={styles.loader}>
      <div className={styles.loaderInner}>
        <Progress cycled shape='linear' value={100} />
        <Typography className={styles.loaderText} variant='body2'>
          {text}
        </Typography>
      </div>
    </div>
  );
}
